import React from 'react';
import type { ComponentProps } from 'react';
import styled from '@emotion/styled';
import type { HeightProps, WidthProps } from 'styled-system';
import { height, space, width } from 'styled-system';

import { ResponsiveLazyImageMemo } from 'common/components/LazyImage';
import { useLocalization } from 'common/providers/LocaleProvider';
import type { SpaceProps } from 'common/theme/system-types';
import type { BannerProps } from '../../../types';

type LogoImageProps = { logoImage?: BannerProps['logoImage'] };

const InnerLogoImage = styled(ResponsiveLazyImageMemo)<WidthProps & HeightProps & SpaceProps>`
  ${width};
  ${height};
  ${space};
`;

const innerLogoImageStyles: ComponentProps<typeof InnerLogoImage> = {
  width: '72px',
  height: '36px',
};

const LogoImage = ({ logoImage }: LogoImageProps) => {
  const { t } = useLocalization();

  if (!logoImage) return null;

  return <InnerLogoImage {...innerLogoImageStyles} {...logoImage} alt={t('h24_logo_alt_title')} />;
};

export default LogoImage;
